import React, { useState } from 'react';

const ACCENT = '#e71204';

const faqs = [
  {
    question: 'Are there any hidden charges with BookinIndia?',
    answer: 'No, BookinIndia believes in complete transparency. The price you see at the time of booking is the final price you pay. There are no hidden charges or surprise fees at the end of your journey.'
  },
  {
    question: 'Are there any additional charges I should be aware of?',
    answer: 'Toll charges, state taxes, and parking fees (if applicable) may be added to your fare. For outstation trips, a night allowance may apply if the trip extends past midnight. All such charges are mentioned clearly before you confirm your booking.'
  },
  {
    question: 'Are drivers verified and audited?',
    answer: 'Yes, all BookinIndia drivers undergo thorough background verification including police verification, license validation, and periodic audits. We ensure every driver meets our safety and service quality standards before they are onboarded.'
  },
  {
    question: 'What payment methods do you accept?',
    answer: 'BookinIndia accepts multiple payment options including UPI, credit/debit cards, net banking, and cash. You can choose your preferred payment method at the time of booking or after the trip as per convenience.'
  },
  {
    question: 'Can I book a cab for my parents while living abroad?',
    answer: 'Absolutely! BookinIndia allows you to book cabs for your loved ones from anywhere in the world. Simply enter the passenger details during booking, and our driver will coordinate directly with them. You can pay online in advance.'
  },
  {
    question: 'Which regions does BookinIndia serve?',
    answer: 'BookinIndia operates across 500+ cities and towns in India, covering major metros, tier-2 cities, pilgrimage sites, hill stations, and more. We serve Tamil Nadu, Karnataka, Andhra Pradesh, Telangana, Kerala, Maharashtra, and many more states.'
  },
];

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (idx) => {
    setOpenIndex(prev => prev === idx ? null : idx);
  };

  return (
    <div style={{ fontFamily: "'Segoe UI', sans-serif" }}>

      {/* ── DESKTOP ── */}
      <div className="faq-desktop">
        <div style={{
          background: '#ffffff',
          padding: '72px 24px 80px',
        }}>
          <div style={{ maxWidth: '960px', margin: '0 auto' }}>

            <h2 style={{
              textAlign: 'center',
              fontSize: '36px',
              fontWeight: 800,
              color: '#111827',
              marginBottom: '48px',
              letterSpacing: '-0.5px',
            }}>
              Frequently Asked Questions
            </h2>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              {faqs.map((faq, idx) => (
                <div
                  key={idx}
                  style={{
                    border: openIndex === idx
                      ? `1.5px solid #111827`
                      : '1.5px solid #e5e7eb',
                    borderRadius: '12px',
                    overflow: 'hidden',
                    transition: 'border-color 0.2s ease',
                    background: '#fff',
                  }}
                >
                  {/* Question Row */}
                  <button
                    onClick={() => toggle(idx)}
                    style={{
                      width: '100%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      padding: '22px 28px',
                      background: 'none',
                      border: 'none',
                      cursor: 'pointer',
                      textAlign: 'left',
                      gap: '16px',
                    }}
                  >
                    <span style={{
                      fontSize: '15.5px',
                      fontWeight: 600,
                      color: '#111827',
                      lineHeight: '1.4',
                    }}>
                      {faq.question}
                    </span>
                    <span style={{
                      color: ACCENT,
                      fontSize: '24px',
                      fontWeight: 300,
                      lineHeight: 1,
                      flexShrink: 0,
                      transform: openIndex === idx ? 'rotate(45deg)' : 'rotate(0deg)',
                      transition: 'transform 0.25s ease',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}>
                      +
                    </span>
                  </button>

                  {/* Answer */}
                  {openIndex === idx && (
                    <div style={{
                      padding: '0 28px 22px',
                      animation: 'fadeSlideDown 0.2s ease',
                    }}>
                      <div style={{
                        height: '1px',
                        background: '#f0f0f0',
                        marginBottom: '16px',
                      }} />
                      <p style={{
                        fontSize: '14.5px',
                        color: '#4b5563',
                        lineHeight: '1.7',
                        margin: 0,
                      }}>
                        {faq.answer}
                      </p>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* ── MOBILE ── */}
      <div className="faq-mobile">
        <div style={{
          background: '#f2f3f7',
          padding: '32px 16px 40px',
        }}>

          <h2 style={{
            fontSize: '26px',
            fontWeight: 800,
            color: '#111827',
            marginBottom: '24px',
            lineHeight: '1.2',
            letterSpacing: '-0.3px',
          }}>
            Frequently Asked Questions
          </h2>

          <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
            {faqs.map((faq, idx) => (
              <div
                key={idx}
                style={{
                  background: '#ffffff',
                  borderRadius: '14px',
                  overflow: 'hidden',
                  boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
                }}
              >
                {/* Question Row */}
                <button
                  onClick={() => toggle(idx)}
                  style={{
                    width: '100%',
                    display: 'flex',
                    alignItems: 'flex-start',
                    justifyContent: 'space-between',
                    padding: '18px 18px',
                    background: 'none',
                    border: 'none',
                    cursor: 'pointer',
                    textAlign: 'left',
                    gap: '12px',
                  }}
                >
                  <span style={{
                    fontSize: '14.5px',
                    fontWeight: 600,
                    color: '#111827',
                    lineHeight: '1.45',
                    flex: 1,
                  }}>
                    {faq.question}
                  </span>
                  <span style={{
                    color: ACCENT,
                    fontSize: '22px',
                    fontWeight: 300,
                    lineHeight: 1,
                    flexShrink: 0,
                    marginTop: '2px',
                    transform: openIndex === idx ? 'rotate(45deg)' : 'rotate(0deg)',
                    transition: 'transform 0.25s ease',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}>
                    +
                  </span>
                </button>

                {/* Answer */}
                {openIndex === idx && (
                  <div style={{
                    padding: '0 18px 18px',
                    animation: 'fadeSlideDown 0.2s ease',
                  }}>
                    <div style={{
                      height: '1px',
                      background: '#f0f0f0',
                      marginBottom: '12px',
                    }} />
                    <p style={{
                      fontSize: '13.5px',
                      color: '#4b5563',
                      lineHeight: '1.65',
                      margin: 0,
                    }}>
                      {faq.answer}
                    </p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>

      <style>{`
        .faq-desktop { display: block; }
        .faq-mobile  { display: none;  }

        @media (max-width: 767px) {
          .faq-desktop { display: none !important;  }
          .faq-mobile  { display: block !important; }
        }

        @keyframes fadeSlideDown {
          from { opacity: 0; transform: translateY(-6px); }
          to   { opacity: 1; transform: translateY(0);    }
        }
      `}</style>
    </div>
  );
};

export default FAQ;